import React from "react"

const FILTERS = [
  { key: "all", label: "All" },
  { key: "none", label: "No upload" },
  { key: "not-placed", label: "Not placed" },
  { key: "placed", label: "Placed" },
]

/**
 * Filter pills for the sidebar building list.
 *
 * @param {Object} props
 * @param {string} props.activeFilter - Currently active filter key
 * @param {Function} props.onFilterChange - Callback when filter changes
 * @param {{all: number, none: number, "not-placed": number, placed: number}} props.counts - Count per status
 * @returns {React.ReactElement} Filter pills row
 */
export function SidebarFilterPills({ activeFilter, onFilterChange, counts }) {
  return (
    <div className="file-upload-filter-pills" role="radiogroup" aria-label="Filter floors">
      {FILTERS.map(filter => {
        const count = filter.key !== "all" ? counts[filter.key] : null
        return (
          <button
            type="button"
            key={filter.key}
            className={`file-upload-filter-pill${activeFilter === filter.key ? " active" : ""}`}
            role="radio"
            aria-checked={activeFilter === filter.key}
            onClick={() => onFilterChange(filter.key)}
          >
            {filter.label}
            {count != null && (
              <span className="pill-count">{count}</span>
            )}
          </button>
        )
      })}
    </div>
  )
}
